export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7182.4f569e9a.jpg";